import React, { useState, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";

import {
  normalizeTwoWords,
  findRel,
} from "../../../shared/utils/stringUtilities";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import NavAccordion from "../../atoms/nav-accordion/navAccordion";
import FontSize from "../../atoms/font-size/fontSize";
import Searcher from "../../molecules/searcher/searcher";

import { FaSearch, FaTimes } from "react-icons/fa";
import "./navMenu.scss";
import Button from "../../atoms/button/button";
import Icon from "../../atoms/icon/Icon";
import Switch from "../../atoms/switch/switch";

const NavMenu = (props: NavMenuInterface) => {
  const { isMenuActive, isSearcherActive, setSearcherActive } = props;
  const { document } = useBrowserMode();
  const [activeItem, setActiveItem] = useState(0);
  const [isAnyActive, setIsAnyActive] = useState(true);
  const [showFontSize, setShowFontSize] = useState(false);

  const data = useStaticQuery(graphql`
    query MENU_CATEGOIAS {
      allContentfulMenuPrincipal(filter: { titulo: { eq: "Menu Revista" } }) {
        nodes {
          referenciaCategorias {
            nombreCategoria
            slug
            hyperLink
            referenciaSubcategorias {
              nombreSubcategoria
              slug
              link
              verEnMenu
              referenciaSubcategorias {
                nombreSubcategoria
                slug
                link
                verEnMenu
              }
            }
          }
        }
      }
      allContentfulFooter(filter: { titulo: { eq: "Footer Revista" } }) {
        nodes {
          titulo
          referenciaCategorias {
            nombreCategoria
            referenciaSubcategorias {
              titulo
              link
              nombreSubcategoria
            }
          }
        }
      }
    }
  `);

  const queryFooter = data.allContentfulFooter.nodes[0].referenciaCategorias;
  const query = queryFooter.filter(
    (item: any) => item.nombreCategoria === "Síguenos"
  )[0];
  const closeMenu = () => {
    toogleFreeze(false);
    props.setMenuActive(false);
  };
  const toogleFreeze = (isToggle: boolean) => {
    isToggle
      ? document.body.classList.add("freeze-page")
      : document.body.classList.remove("freeze-page");
  };

  const {
    referenciaCategorias,
    listaDerecha,
  } = data.allContentfulMenuPrincipal.nodes[0];

  useEffect(() => {
    const menu = document.querySelector(".m-nav-menu");
    if (menu) menu.scrollTop = 0;
  }, [isMenuActive === true]);

  const handleSearcher = () => {
    toogleFreeze(!props.isSearcherActive);
    props.setSearcherActive(true);
    props.isMenuActive && props.setMenuActive(false);
  };

  return (
    <nav
      className={`m-nav-menu ${
        isMenuActive || isSearcherActive ? "" : "m-nav-menu--hide"
      }`}
    >
      {isSearcherActive ? (
        <Searcher setSearcherActive={setSearcherActive} type="comfama" />
      ) : (
        <React.Fragment>
          <div className="m-nav-menu__body">
            <div className="m-nav-menu__body__btn">
              <Button
                isDisabled={false}
                type="button"
                classname="icon"
                IconAlt={<FaTimes />}
                text="cerrar"
                onClickAction={() => closeMenu()}
              />
            </div>
            <div className="m-nav-menu__accordion">
              {referenciaCategorias &&
                referenciaCategorias.map((cat, i) => (
                  <NavAccordion
                    key={`cat${i}`}
                    index={i}
                    category={cat}
                    activeItem={activeItem}
                    setActiveItem={setActiveItem}
                    isAnyActive={isAnyActive}
                    setIsAnyActive={setIsAnyActive}
                  />
                ))}
            </div>
          </div>

          <div className="m-nav-menu__actions">
            <div className="m-nav-menu__actions-search">
              <FaSearch
                className="hide-mobile icon gtmMenuTransBuscar"
                onClick={handleSearcher}
              />
            </div>
            <div className="m-nav-menu__actions-font">
              <i
                className="icon icon-font-change-2 gtmMenuTransTamanoLetra"
                onClick={() => setShowFontSize(!showFontSize)}
              />
              {showFontSize && (
                <div className="float-box">
                  <FontSize setShowFontSize={setShowFontSize} />
                </div>
              )}
            </div>
            <Switch />
          </div>
          <div
            className={`m-nav-menu__links ${
              !isAnyActive ? "m-nav-menu__links--locked" : ""
            }`}
          >
            <ul className="m-nav-menu__links-list">
              {listaDerecha &&
                listaDerecha.map((link, i) => (
                  <li
                    key={`cat${i}`}
                    className={`gtmMenuTransLateral${normalizeTwoWords(
                      link.nombreCategoria
                    )}`}
                  >
                    <a
                      className={`gtmMenuTransLateral${normalizeTwoWords(
                        link.nombreCategoria
                      )}`}
                      href={link.hyperLink || "/" + link.slug}
                      target={link.hyperLink ? "_blank" : "_self"} //Temporal. Remove this when new contact center is avaliable
                      rel={findRel(link.hyperLink)}
                    >
                      {" "}
                      {link.nombreCategoria}{" "}
                    </a>
                  </li>
                ))}
            </ul>

            <div className="m-nav-menu__links-social">
              {/* <p>Síguenos en nuestras redes</p> */}
              <ul>
                {query.referenciaSubcategorias.map((val, key) => (
                  <li
                    key={`followItem-${key}`}
                    className={`gtm${normalizeTwoWords(val.titulo)}`}
                  >
                    <a
                      href={val.link}
                      className={`gtm${normalizeTwoWords(val.titulo)}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Icon
                        icon={val.nombreSubcategoria}
                        classname="m-nav-menu__links-social__icon"
                      />
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/*<p className="m-nav-menu__links-more">
              <span>
                Conoce más en{" "}
                <a href="/" target="_blank" rel="follow">
                  Comfama.com
                </a>
              </span>
                      </p>*/}
          </div>

          {/* <RecommenderModal
            open={isRecommenderOpen}
            onClose={() => setIsRecommenderOpen(false)}
          /> */}
        </React.Fragment>
      )}
    </nav>
  );
};

interface NavMenuInterface {
  isMenuActive: boolean;
  isSearcherActive: boolean;
  sideLinks: any;
  setSearcherActive: () => void;
  setMenuActive: (isMenuActive: boolean) => void;
  isDark: boolean;
  actionTheme: () => void;
}

export default NavMenu;
